import { Component } from '@angular/core';
import { FormComponent } from '@ubud/form';
import { RegisterInstitutionCommunity } from '@lemsar/auth/domains/models/register';

@Component({
    selector: 'lemsar-register-institution-community-form',
    templateUrl: './register-institution-community.form.html',
})
export class RegisterInstitutionCommunityForm extends FormComponent<RegisterInstitutionCommunity> {
    public taxMask: string = '99.999.999.9-999.999';
    public identityMask: string = '9999999999999999';

    public onChange(name: string, event: any): void {
        // this.form.formGroup.get(name)!.setValue(event);
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/views/components/register-institution-community.form.ts